import { dataHooks } from '@wix/data-hooks';

export const templatePreviewModalDataHooks = dataHooks<{
  container: { key: string };
  previewHeader: { key: string };
  templateSaved: { key: string };
  templateDemoPreview: { key: string };
  templateDemoPreviewIframe: { key: string };
}>('template-preview-modal');
